//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TooltipAjuda from '../../../../../shared-components/TooltipAjuda';
import filtroClienteResources from '../../../../../common/resources/filtro-cliente';
import exportacao from '../../../../../common/resources/exportacoes';

export default {
  name: 'TransferenciaPosseDefinitivaPasso3',
  components: {
    TooltipAjuda,
  },
  props: {
    transferencia: Object,
  },
  data() {
    return {
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),
      filtroClienteResource: filtroClienteResources(this.$resource),
      fetchRegiaoFunction: this.$api.regiao(this.$resource).listar,
      fetchExtensaoFuncion: this.$api.extensao(this.$resource).listar,
      fetchClienteFunction: this.$api.cliente(this.$resource).listarFiltrado,

      passo: 3,
      clientes: [],
      pagination: {},
      totalPage: 0,
      headers: [
        { text: this.$tc('label.codigo', 1), value: 'idExterno', sortable: false },
        { text: this.$tc('label.nome', 1), value: 'nomCliente', sortable: false },
        { text: this.$tc('label.cnpj', 1), value: 'desCnpj', sortable: false },
        { text: this.$tc('label.holding', 1), value: 'holding', sortable: false },
        { text: this.$tc('label.regiao', 1), value: 'nomRegiao', sortable: false },
        { text: `${this.$tc('label.transferir', 1)}?`, value: 'transferir', sortable: false },
      ],
      filtros: [],
      filtroSelecionado: {},
      lista: [],
      itensFiltro: [],
      buscaLista: null,
      selecionados: [],
    };
  },
  watch: {
    buscaLista(val) {
      if (this.timeoutDe) {
        window.clearTimeout(this.timeoutDe);
      }
      this.timeoutDe = window.setTimeout(() => {
        if (val) this.buscarLista(val);
      }, 500);
    },
    pagination: {
      handler() {
        this.buscarResponsaveis(this.transferencia.funcionarioDe,
          this.transferencia.funcionarioPara);
      },
      deep: true,
    },
  },
  methods: {
    cancelar() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_CANCELAR');
    },
    proximoPasso() {
      if (this.transferencia.transferenciaResponsavelFaturamento === 1) {
        this.transferencia.clientes = this.clientes;
      } else if (this.transferencia.transferenciaResponsavelFaturamento === 2) {
        if (!this.clientes.length) {
          this.$toast.create(this.$t('message.nenhum_cliente_para_transferir'), 'snack', 3E3);
          return;
        }
        this.transferencia.clientes = this.clientes;
      } else if (this.transferencia.transferenciaResponsavelFaturamento === 3) {
        const selecionados = this.clientes.filter(p => p.transferir);
        if (!selecionados.length) {
          this.$toast.create(this.$t('message.nenhum_cliente_selecionado_para_transferir'), 'snack', 3E3);
          return;
        }
        this.transferencia.clientes = selecionados;
      }
      this.$emit('TRANSFERENCIA_DEFINITIVA_CONTINUAR', this.passo + 1, this.transferencia);
    },
    voltarPasso() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_VOLTAR', this.passo - 1);
    },
    buscarResponsaveis(funcDe, funcPara) {
      if (funcDe
        && funcPara) {
        const params = {
          numeroPagina: this.pagination.page,
          tamanhoPagina: this.pagination.itemsPerPage,
          idUsuarioDe: funcDe.id,
          idUsuarioPara: funcPara.id,
        };

        if (this.filtroSelecionado.nomCampoId) {
          params[this.filtroSelecionado.nomCampoId] = this.itensFiltro;
        }

        this.resources.listarResponsaveis(params).then((response) => {
          this.clientes = response.data.resposta;
          this.selecionados.forEach((s) => {
            const cli = this.clientes.filter(
              c => c.idCliente === s.idCliente);
            if (cli && cli.length) {
              cli[0].transferir = true;
            }
          });
          this.totalPage = response.data.quantidadeRegistrosPagina;
        }, (err) => {
          this.$error(this, err);
        });
      }
    },
    buscarFiltros() {
      this.filtroClienteResource.listarAtivos()
        .then((response) => {
          const objetos = response.body.resposta;
          if (!objetos || !objetos.length) {
            return;
          }
          this.filtros = objetos;
          this.filtros.forEach((f) => {
            f.nome = this.$t(`label.filtro_cliente_${f.nomCampoId}`);
          });
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarLista(busca = null) {
      if (this.filtroSelecionado.nomCampoId) {
        if (typeof busca !== 'string') {
          busca = null;
        }
        const param = {
          nome: busca,
          indAtivo: true,
          size: 20,
          page: 1,
        };

        if (this.filtroSelecionado.nomCampoId === 'id_regiao') {
          this.buscarRegiao(param);
        } else if (this.filtroSelecionado.nomCampoId === 'id_cliente') {
          param.filter = busca;
          this.buscarCliente(param);
        } else {
          // id_holding
          param.idNivelExtensao = this.filtroSelecionado.idNivelExtensao;
          this.buscarExtensao(param);
        }
      }
    },
    buscarRegiao(param) {
      this.fetchRegiaoFunction(param).then((response) => {
        response.data = response.data.resposta.map((el) => {
          const rt = {
            nome: el.nomRegiao,
            id: el.id,
            codRegiao: el.codRegiao,
          };

          return rt;
        });

        this.lista = response.data;
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    buscarExtensao(param) {
      param.idUsuario = this.transferencia.funcionarioDe.id;
      this.fetchExtensaoFuncion(param).then((response) => {
        response.data = response.data.resposta.map((el) => {
          const rt = {
            nome: el.nomExtensao,
            id: el.id,
            idExterno: el.idExterno,
          };

          return rt;
        });

        this.lista = response.data;
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    buscarCliente(param) {
      this.fetchClienteFunction(param).then((response) => {
        response.data = response.data.resposta.map((el) => {
          const rt = {
            nome: el.cod_nom_cliente,
            id: el.id,
            idExterno: el.idExterno,
          };

          return rt;
        });

        this.lista = response.data;
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    limparFiltro() {
      this.lista = [];
      this.itensFiltro = [];
      this.selecionados = [];
    },
    aplicarFiltro() {
      this.selecionados = [];
      this.pagination.page = 1;
      this.buscarResponsaveis(this.transferencia.funcionarioDe, this.transferencia.funcionarioPara);
    },
    exportar() {
      const resource = exportacao(this.$http);
      const parametrosConsulta = {
        idUsuarioDe: this.transferencia.funcionarioDe.id,
        idUsuarioPara: this.transferencia.funcionarioPara.id,
      };
      // if (this.filtroSelecionado.nomCampoId) {
      //  parametrosConsulta[this.filtroSelecionado.nomCampoId] = this.itensFiltro;
      // }
      resource.download('transferencia-definitiva-responsavel',
        { limit: 500, parametrosConsulta }, 'usuario')
        .then(() => this.$toast.create(this.$t('message.exportacao_download'), 'snack', 3E3))
        .catch(() => this.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3));
    },
    selecionar(item) {
      if (item.transferir) {
        this.selecionados.push(item);
      } else {
        this.selecionados.splice(this.selecionados.indexOf(item), 1);
      }
    },
  },
  mounted() {
    this.buscarFiltros();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaPosseDefinitivaPasso3.vue?vue&type=script&lang=js&